const API_BASE = import.meta.env.VITE_API_URL || '';

export function apiUrl(path: string): string {
  if (path.startsWith('http')) return path;
  const base = API_BASE.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
}

export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(apiUrl(path), {
    ...init,
    credentials: 'include',
  });
}
